import { render, staticRenderFns } from "./DiagSectionList.vue?vue&type=template&id=765e62f3&scoped=true&"
import script from "./DiagSectionList.vue?vue&type=script&lang=js&"
export * from "./DiagSectionList.vue?vue&type=script&lang=js&"
import style0 from "./DiagSectionList.vue?vue&type=style&index=0&id=765e62f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e62f3",
  null
  
)

export default component.exports